import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const PATH =
  'M76.361 35.667a3.148 3.148 0 0 0-4.454 0L49.92 57.652 28.093 35.823a3.149 3.149 0 1 0-4.454 4.454l24.055 24.056a3.148 3.148 0 0 0 4.454 0c.029-.028.037-.068.065-.1s.066-.035.093-.063l24.055-24.05a3.148 3.148 0 0 0 0-4.453z'

const IconCaretDown: FC<IconProps> = props => <SvgIcon {...props} path={PATH} />

export default IconCaretDown
